import React from "react";
import { useTranslation } from "../hooks/useTranslation";

const NoAccessPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center items-center h-screen bg-black text-red-500">
      <h4>{t('auth.messages.noAccessUrlMayBeWrong')}</h4>
    </div>
  );
};

export default NoAccessPage;
